/**
 * Route for `advertiser-publisher-stats`. Registered via createRoute; root
 * wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserPublisherStatsPage } from "../features/advertiser-publisher-stats/AdvertiserPublisherStatsPage";

export const advertiserPublisherStatsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-publisher-stats",
	component: AdvertiserPublisherStatsPage,
});

export default advertiserPublisherStatsRoute;
